import { Center, Loader, Paper } from '@mantine/core';
import React from 'react';
import CompanySectionLayout from './CompanySectionLayout';

type Props = {
  title?: string;
};

export default function CompanyPageLoadingSection({ title }: Props) {
  if (title) {
    return (
      <CompanySectionLayout title={title}>
        <Center h={400}>
          <Loader />
        </Center>
      </CompanySectionLayout>
    );
  }

  return (
    <Paper variant="content" p="xxl">
      <Center h={400}>
        <Loader />
      </Center>
    </Paper>
  );
}
